import { render, staticRenderFns } from "./TraxUiModalPlainHeader.vue?vue&type=template&id=19dcb319"
import script from "./TraxUiModalPlainHeader.vue?vue&type=script&lang=js"
export * from "./TraxUiModalPlainHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports